import { hashHistory } from 'react-router';
import queryString from 'query-string';

// All paths
const PATHS = {
  PURCHASE: 'purchase',
};

// Exported paths
export const PURCHASE_PATH = PATHS.PURCHASE;

// Root
const CPM_PURCHASE_PATH = `${PURCHASE_PATH}`;

export const purchasePath = (queryParams) => {
  const search = queryParams ? `?${queryString.stringify(queryParams, { encode: true })}` : '';
  return `${CPM_PURCHASE_PATH}${search}`;
};

export const navigateToPurchase = (queryParams) => {
  hashHistory.push(purchasePath(queryParams));
};



// WEBPACK FOOTER //
// ./routes/purchase/navigation.js